/**
 * Tricoci Shopify — pass landing UTMs to Zenoti booking links only.
 *
 * Meta ads and GA4 both use the same standard UTM keys (see UTM_KEYS):
 *   utm_source, utm_medium, utm_campaign, utm_content, utm_term
 *
 * Meta (Facebook / Instagram ads) — set in Ads Manager URL parameters:
 *   utm_source=facebook|instagram
 *   utm_medium=paid-social
 *   utm_campaign=<name of ad>
 *   utm_content={{adset.name}}
 *   utm_term={{campaign.name}}
 *
 * GA4 channel taxonomy — medium + source values (channel group is derived in GA4):
 *   utm_medium  → influencer, social, paid-social, cpc, sms, affiliate, ctv, email, display
 *   utm_source  → facebook, instagram, google, klaviyo, zenoti, web, …
 *
 * Important: bare book.tricoci.com and /webstoreNew/ redirect to
 * /webstoreNew/services and Zenoti often DROPS query params on that redirect.
 * We rewrite those short URLs to /webstoreNew/services BEFORE adding UTMs.
 *
 * Site navigation: stored UTMs + trackId are restored to the address bar (replaceState)
 * and appended to same-site / booking links for GA4 and Zenoti TRK (GTM-NBL2B9NZ).
 *
 * trackId — funnel session id (URL param trackId, storage tricoci_track_id); passed to
 * book.tricoci.com so Site B Zenoti tracking can continue the same session.
 *
 * Skips gift cards, series packages, sales, sign-in, and cart/product CTAs.
 */
(function () {
  "use strict";

  if (window.__tricociBookingUtmInit) return;
  window.__tricociBookingUtmInit = true;

  var STORAGE_KEY = "tricoci_landing_utms";
  var TRACK_ID_PARAM = "trackId";
  var TRACK_ID_STORAGE_KEY = "tricoci_track_id";
  var UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

  /**
   * Meta Ads Manager URL parameter templates (reference only — same UTM_KEYS as GA4).
   * Paste into Facebook / Instagram ad tracking → URL parameters.
   */
  var META_UTM_TEMPLATES = {
    facebook: {
      utm_source: "facebook",
      utm_medium: "paid-social",
      utm_campaign: "<name of ad>",
      utm_content: "{{adset.name}}",
      utm_term: "{{campaign.name}}"
    },
    instagram: {
      utm_source: "instagram",
      utm_medium: "paid-social",
      utm_campaign: "<name of ad>",
      utm_content: "{{adset.name}}",
      utm_term: "{{campaign.name}}"
    },
    /** Single query string for Ads Manager (Facebook example) */
    facebookQuery:
      "utm_source=facebook&utm_medium=paid-social&utm_campaign=<name of ad>" +
      "&utm_content={{adset.name}}&utm_term={{campaign.name}}",
    instagramQuery:
      "utm_source=instagram&utm_medium=paid-social&utm_campaign=<name of ad>" +
      "&utm_content={{adset.name}}&utm_term={{campaign.name}}"
  };

  /**
   * Tricoci GA4 channel taxonomy (reference only — same UTM_KEYS as Meta).
   * Map medium + source in campaign links; GA4 assigns the channel group.
   */
  var GA4_CHANNEL_GROUPS = [
    {
      group: "Influencer",
      medium: "influencer",
      sources: [
        "facebook", "instagram", "tiktok", "youtube", "OOH", "qrcode",
        "printadmagazine", "lightbox", "affiliate", "email", "tv"
      ]
    },
    {
      group: "Organic Social",
      medium: "social",
      sources: ["facebook", "instagram", "tiktok", "linkedin"]
    },
    {
      group: "Paid Social",
      medium: "paid-social",
      sources: ["facebook", "instagram", "tiktok"]
    },
    {
      group: "Paid Search",
      medium: "cpc",
      sources: ["google"]
    },
    {
      group: "SMS",
      medium: "sms",
      sources: ["zenoti", "klaviyo"]
    },
    {
      group: "Affiliate",
      medium: "affiliate",
      sources: ["web"]
    },
    {
      group: "Paid Video",
      medium: "ctv",
      sources: ["rokutv", "vibe"]
    },
    {
      group: "Email",
      medium: "email",
      sources: ["klaviyo", "zenoti"]
    },
    {
      group: "Display",
      medium: "display",
      sources: ["web"]
    }
  ];
  var BOOKING_HOSTS = {
    "book.tricoci.com": true,
    "mariotricoci.zenoti.com": true
  };
  var EXCLUDED_PATH_RE = /\/(giftcards|sales\/|seriespackage|user\/)(\/?|$)/i;
  var PURCHASE_LABEL_RE = /^(buy\s*now|purchase\s*now|add\s*to\s*cart|shop\s*now)$/i;
  function cfg() {
    return window.TRICOCI_BOOKING_UTM || {};
  }

  function log() {
    if (!cfg().debug) return;
    var args = ["[Tricoci booking UTM]"].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  function norm(val) {
    return String(val || "").trim().toLowerCase();
  }

  function resolveChannelGroup(medium, source) {
    var m = norm(medium);
    if (!m) return "";

    var s = norm(source);
    for (var i = 0; i < GA4_CHANNEL_GROUPS.length; i++) {
      var row = GA4_CHANNEL_GROUPS[i];
      if (norm(row.medium) !== m) continue;
      if (!s) return row.group;
      for (var j = 0; j < row.sources.length; j++) {
        if (norm(row.sources[j]) === s) return row.group;
      }
    }
    return "";
  }

  function readUtmsFromSearch(search) {
    var p = new URLSearchParams(search || "");
    var out = {};
    UTM_KEYS.forEach(function (key) {
      var val = (p.get(key) || "").trim();
      if (val) out[key] = val;
    });
    return out;
  }

  function readTrackIdFromSearch(search) {
    return (new URLSearchParams(search || "").get(TRACK_ID_PARAM) || "").trim();
  }

  function captureLandingParams() {
    var fromUrl = readUtmsFromSearch(window.location.search);
    var trackIdFromUrl = readTrackIdFromSearch(window.location.search);
    var captured = false;

    if (Object.keys(fromUrl).length) {
      var stored = {};
      try {
        stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}") || {};
      } catch (e) {
        stored = {};
      }

      var merged = Object.assign({}, stored, fromUrl);
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
      } catch (e) {}
      log("captured utms", merged);
      captured = true;
    }

    if (trackIdFromUrl) {
      try {
        sessionStorage.setItem(TRACK_ID_STORAGE_KEY, trackIdFromUrl);
      } catch (e) {}
      log("captured trackId", trackIdFromUrl);
      captured = true;
    }

    return captured;
  }

  function captureLandingUtms() {
    captureLandingParams();
    return activeUtms();
  }

  function storedUtms() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}") || {};
    } catch (e) {
      return {};
    }
  }

  function storedTrackId() {
    try {
      return sessionStorage.getItem(TRACK_ID_STORAGE_KEY) || "";
    } catch (e) {
      return "";
    }
  }

  function activeUtms() {
    return Object.assign({}, storedUtms(), readUtmsFromSearch(window.location.search));
  }

  function activeTrackId() {
    return readTrackIdFromSearch(window.location.search) || storedTrackId();
  }

  function hasUtms(utms) {
    return !!(utms && (utms.utm_source || utms.utm_medium || utms.utm_campaign || utms.utm_content || utms.utm_term));
  }

  function hasTrackId(trackId) {
    return !!(trackId && String(trackId).trim());
  }

  function hasTrackingParams(utms, trackId) {
    return hasUtms(utms || activeUtms()) || hasTrackId(trackId != null ? trackId : activeTrackId());
  }

  function persistEnabled() {
    return cfg().persistInAddressBar !== false;
  }

  function syncInternalEnabled() {
    return cfg().syncInternalLinks !== false;
  }

  function isSkippableHref(href) {
    if (!href) return true;
    var lower = href.trim().toLowerCase();
    return (
      lower.indexOf("javascript:") === 0 ||
      lower.indexOf("mailto:") === 0 ||
      lower.indexOf("tel:") === 0 ||
      lower === "#"
    );
  }

  function isSameSiteUrl(url) {
    return !!(url && url.hostname === window.location.hostname);
  }

  /** Append landing UTMs + trackId; preserves _gl, gclid, and other query params. */
  function appendTrackingToUrl(href, utms, trackId, options) {
    var url = parseHref(href);
    if (!url) return href;

    var resolvedTrackId = trackId != null ? trackId : activeTrackId();
    var resolvedUtms = utms || activeUtms();
    if (!hasUtms(resolvedUtms) && !hasTrackId(resolvedTrackId)) return href;

    var opts = options || {};
    if (opts.sameSiteOnly !== false && !isSameSiteUrl(url)) return href;
    if (opts.bookingOnly && !isBookingUrl(url)) return href;

    if (opts.bookingOnly) {
      url = canonicalizeBookingUrl(url);
    }

    UTM_KEYS.forEach(function (key) {
      if (!resolvedUtms[key]) return;
      url.searchParams.set(key, resolvedUtms[key]);
    });

    if (hasTrackId(resolvedTrackId)) {
      url.searchParams.set(TRACK_ID_PARAM, resolvedTrackId);
    }

    return url.toString();
  }

  function appendUtmsToUrl(href, utms, options) {
    return appendTrackingToUrl(href, utms, null, options);
  }

  function urlMissingStoredParams(utms, trackId) {
    var currentUtms = readUtmsFromSearch(window.location.search);
    var utmMissing = UTM_KEYS.some(function (key) {
      return utms[key] && currentUtms[key] !== utms[key];
    });
    var trackMissing = hasTrackId(trackId) &&
      readTrackIdFromSearch(window.location.search) !== trackId;
    return utmMissing || trackMissing;
  }

  function urlMissingStoredUtms(utms) {
    return urlMissingStoredParams(utms, activeTrackId());
  }

  /** Keep UTMs + trackId in the address bar for GA4 / Zenoti TRK on every page view. */
  function persistTrackingInAddressBar() {
    if (!persistEnabled()) return;

    var utms = activeUtms();
    var trackId = activeTrackId();
    if (!hasTrackingParams(utms, trackId) || !urlMissingStoredParams(utms, trackId)) return;

    var url = new URL(window.location.href);
    UTM_KEYS.forEach(function (key) {
      if (utms[key]) url.searchParams.set(key, utms[key]);
    });
    if (hasTrackId(trackId)) url.searchParams.set(TRACK_ID_PARAM, trackId);

    history.replaceState(history.state, "", url.pathname + url.search + url.hash);
    log("address bar", url.search);
  }

  function persistUtmsInAddressBar() {
    persistTrackingInAddressBar();
  }

  function parseHref(href) {
    if (!href) return null;
    try {
      return new URL(href, window.location.href);
    } catch (e) {
      return null;
    }
  }

  function isInsidePurchaseControl(el) {
    if (!el || !el.closest) return false;
    if (el.closest("[data-add-to-cart], [data-add-to-cart-form], product-form, .product-form, .shopify-payment-button")) {
      return true;
    }
    var form = el.closest("form");
    if (form) {
      var action = (form.getAttribute("action") || "").toLowerCase();
      if (action.indexOf("/cart") >= 0) return true;
    }
    return false;
  }

  function linkLabel(el) {
    return String(el.textContent || el.getAttribute("aria-label") || "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  /**
   * Zenoti strips query strings when redirecting short paths → /webstoreNew/services.
   * Point those URLs at /webstoreNew/services so UTMs survive.
   * Preserves existing query (serviceid, CategoryId, etc.).
   */
  function canonicalizeBookingUrl(url) {
    if (!url || !BOOKING_HOSTS[url.hostname.toLowerCase()]) return url;

    var path = (url.pathname || "/").replace(/\/+$/, "") || "/";
    // https://book.tricoci.com  OR  /webstoreNew  OR  /webstoreNew/
    if (path === "/" || /^\/webstoreNew$/i.test(path)) {
      url.pathname = "/webstoreNew/services";
      log("canonicalize → /webstoreNew/services");
    }
    return url;
  }

  function isBookingUrl(url) {
    if (!url || !BOOKING_HOSTS[url.hostname.toLowerCase()]) return false;
    if (EXCLUDED_PATH_RE.test(url.pathname)) return false;
    return true;
  }

  function isBookingAnchor(el) {
    if (!el || el.tagName !== "A") return false;
    if (isInsidePurchaseControl(el)) return false;

    var url = parseHref(el.getAttribute("href"));
    if (!isBookingUrl(url)) return false;

    var label = linkLabel(el);
    if (label && PURCHASE_LABEL_RE.test(label)) return false;

    return true;
  }

  function buildTrackedUrl(href, utms, trackId) {
    return appendTrackingToUrl(href, utms, trackId, { sameSiteOnly: false, bookingOnly: true });
  }

  function isInternalAnchor(el) {
    if (!el || el.tagName !== "A") return false;
    if (!syncInternalEnabled()) return false;

    var href = el.getAttribute("href");
    if (isSkippableHref(href)) return false;

    var url = parseHref(href);
    if (!isSameSiteUrl(url)) return false;
    if (isBookingUrl(url)) return false;

    return true;
  }

  function syncInternalAnchor(el) {
    if (!isInternalAnchor(el)) return null;

    var href = el.getAttribute("href");
    if (!hasTrackingParams()) return href;

    var next = appendTrackingToUrl(href, activeUtms(), activeTrackId(), { sameSiteOnly: true });
    if (next && next !== href) {
      el.setAttribute("href", next);
      el.setAttribute("data-tricoci-utm-internal", "1");
      log("sync internal", next);
    }
    return next || href;
  }

  function syncBookingAnchor(el) {
    if (!isBookingAnchor(el)) return null;
    var href = el.getAttribute("href");
    if (isSkippableHref(href)) return null;

    if (!hasTrackingParams()) return href;

    var next = buildTrackedUrl(href, activeUtms(), activeTrackId());
    if (next && next !== href) {
      el.setAttribute("href", next);
      el.setAttribute("data-tricoci-utm", "1");
      log("sync booking", next);
    }
    return next || href;
  }

  function syncAnchor(el) {
    syncInternalAnchor(el);
    return syncBookingAnchor(el);
  }

  function syncAll(root) {
    var scope = root || document;
    if (syncInternalEnabled()) {
      scope.querySelectorAll("a[href]").forEach(syncInternalAnchor);
    }
    scope.querySelectorAll(
      "a[href*='book.tricoci.com'], a[href*='mariotricoci.zenoti.com']"
    ).forEach(syncBookingAnchor);
  }

  function onPointer(e) {
    var el = e.target && e.target.closest ? e.target.closest("a") : null;
    if (!el) return;
    syncInternalAnchor(el);
    syncBookingAnchor(el);
  }

  function onClick(e) {
    if (e.defaultPrevented) return;
    if (e.button != null && e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var el = e.target && e.target.closest ? e.target.closest("a") : null;
    if (!el || !isBookingAnchor(el)) return;

    var utms = activeUtms();
    var trackId = activeTrackId();
    if (!hasTrackingParams(utms, trackId)) {
      log("click (no tracking stored)", el.getAttribute("href"));
      return;
    }

    var next = buildTrackedUrl(el.getAttribute("href"), utms, trackId);
    if (!next) return;

    // Force navigation with UTMs — covers Zenoti short-URL redirects stripping params
    e.preventDefault();
    e.stopPropagation();
    el.setAttribute("href", next);
    log("navigate", next);

    var target = (el.getAttribute("target") || "").toLowerCase();
    if (target === "_blank") {
      window.open(next, "_blank", "noopener,noreferrer");
    } else {
      window.location.assign(next);
    }
  }

  function watchDom() {
    if (typeof MutationObserver === "undefined") return;
    var timer = null;
    var obs = new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        syncAll(document);
      }, 150);
    });
    obs.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["href"]
    });
  }

  function boot() {
    if (!window.__tricociBookingUtmEarlyDone) {
      captureLandingParams();
      persistTrackingInAddressBar();
    }
    syncAll(document);
    document.addEventListener("pointerdown", onPointer, true);
    document.addEventListener("mousedown", onPointer, true);
    document.addEventListener("touchstart", onPointer, { capture: true, passive: true });
    document.addEventListener("focusin", onPointer, true);
    document.addEventListener("click", onClick, true);
    watchDom();
    // Re-apply after late PageFly / app widgets
    setTimeout(function () { syncAll(document); }, 800);
    setTimeout(function () { syncAll(document); }, 2500);
    log("ready", { utms: activeUtms(), trackId: activeTrackId() });
  }

  // Expose helpers for console debugging
  window.TRICOCI_BOOKING_UTM = Object.assign({
    debug: false,
    persistInAddressBar: true,
    syncInternalLinks: true,
    UTM_KEYS: UTM_KEYS,
    TRACK_ID_PARAM: TRACK_ID_PARAM,
    TRACK_ID_STORAGE_KEY: TRACK_ID_STORAGE_KEY,
    syncAll: syncAll,
    activeUtms: activeUtms,
    activeTrackId: activeTrackId,
    appendUtmsToUrl: appendUtmsToUrl,
    appendTrackingToUrl: appendTrackingToUrl,
    buildTrackedUrl: buildTrackedUrl,
    persistUtmsInAddressBar: persistUtmsInAddressBar,
    persistTrackingInAddressBar: persistTrackingInAddressBar,
    resolveChannelGroup: resolveChannelGroup,
    META_UTM_TEMPLATES: META_UTM_TEMPLATES,
    GA4_CHANNEL_GROUPS: GA4_CHANNEL_GROUPS
  }, cfg());

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
